import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import './styles/index.css'

const CN_DOMAINS = import.meta.env.VITE_CN_DOMAIN.split(',')
const isCnSite = CN_DOMAINS.includes(location.hostname)

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.mount('#app')

app.mixin({
  methods: {
    getLocaleTitle(caseData: any) {
      const title = isCnSite ? caseData.titleZh : caseData.titleEn
      return title || caseData.title
    }
  }
})